/* This file is autogenerated, see readme.md for instructions */
import SqlSvgIcon from '@bloomreach/banana-theme/icons/sql.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const SqlIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <SqlSvgIcon />
    </Icon>
  );
});

SqlIcon.displayName = 'SqlIcon';

export default SqlIcon;
